import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Auth from './pages/Auth';
import Dashboard from './pages/Dashboard';
import Events from './pages/Events';
import Passes from './pages/Passes';
import Gate from './pages/Gate';
import VenueCalendar from './pages/VenueCalendar';
import Venues from './pages/Venues';
import AoDashboard from './pages/AoDashboard';
import GuestDashboard from './pages/GuestDashboard';

function ProtectedRoute({ children }) {
  const { faculty, loading } = useAuth();
  if (loading)
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          background: 'linear-gradient(180deg, var(--surface-1) 0%, var(--surface-2) 100%)',
        }}
      >
        <div style={{ textAlign: 'center', color: 'var(--text-1)' }}>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.375rem', fontWeight: 800, letterSpacing: '-0.03em', marginBottom: '1rem' }}>
            VisitorPass
          </div>
          <div className="spinner" style={{ margin: '0 auto', width: 34, height: 34 }} />
        </div>
      </div>
    );
  return faculty ? children : <Navigate to="/login" replace />;
}

function AoRoute({ children }) {
  const { faculty } = useAuth();
  if (!faculty || faculty.role !== 'ao') return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRoutes() {
  const { faculty } = useAuth();
  const homeRedirect = faculty?.role === 'ao' ? '/ao' : '/dashboard';
  return (
    <Routes>
      <Route path="/login" element={faculty ? <Navigate to={homeRedirect} replace /> : <Auth />} />
      <Route path="/guest-dashboard" element={<GuestDashboard />} />
      <Route
        path="/gate"
        element={
          <ProtectedRoute>
            <Layout>
              <Gate />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            {faculty?.role === 'ao' ? (
              <Navigate to="/ao" replace />
            ) : (
            <Layout>
              <Dashboard />
            </Layout>
            )}
          </ProtectedRoute>
        }
      />
      <Route
        path="/events"
        element={
          <ProtectedRoute>
            <Layout>
              <Events />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/calendar"
        element={
          <ProtectedRoute>
            <Layout>
              <VenueCalendar />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/venues"
        element={
          <ProtectedRoute>
            <Layout>
              <Venues />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/passes"
        element={
          <ProtectedRoute>
            <Layout>
              <Passes />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/ao"
        element={
          <ProtectedRoute>
            <AoRoute>
              <Layout>
                <AoDashboard />
              </Layout>
            </AoRoute>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to={faculty ? homeRedirect : '/login'} replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3500,
            style: {
              fontFamily: 'var(--font-body)',
              fontSize: '15px',
              borderRadius: '12px',
              boxShadow: 'var(--shadow-lg)',
              padding: '12px 16px',
            },
            success: { iconTheme: { primary: '#0f766e', secondary: 'white' } },
            error: { iconTheme: { primary: '#dc2626', secondary: 'white' } },
          }}
        />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
